import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import { FONT_GSS_FUTURA } from '@monorepo/shared/src/themes/defaultTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { Content } from '../types';

type Props = {
  isSelected: boolean;
  onClick: (tile: Content) => void;
  tile: Content;
};

const LetterTile: React.FC<Props> = ({ isSelected, onClick, tile }) => {
  const classes = styles();
  return (
    <button className={classes.tileContainer} onClick={() => onClick(tile)}>
      <Paper
        elevation={isSelected ? 4 : 0}
        className={`${classes.tile} ${isSelected && classes.selectedTile}`}
      >
        {tile.value}
      </Paper>
    </button>
  );
};

const styles = makeStyles((theme: any) => ({
  selectedTile: {
    color: theme.palette.primary.main,
    border: `none !important`,
  },
  tile: {
    border: `1px solid ${theme.palette.grey[500]}`,
    fontFamily: FONT_GSS_FUTURA,
    fontSize: remCalc(14),
    fontWeight: 'bold',
    height: remCalc(42),
    padding: remCalc(10),
    textAlign: 'center',
    width: remCalc(43),
    '&:hover': {
      cursor: 'pointer',
    },
  },
  tileContainer: {
    background: 'none',
    border: 'none',
    '&:hover': {
      background: 'none',
    },
  },
}));

export default LetterTile;
